// CEO 2026-10-07 · « Mes bons de matériel » : le salarié qui a un compte Prérec signe ici.
import { useCallback, useEffect, useState } from "react";
import { toast } from "sonner";
import { ClipboardCheck, FileDown, CheckCircle2 } from "lucide-react";
import { api } from "../lib/api";
import { openAuthedPdf } from "../lib/pdf";
import NoteSummaryCard from "../components/equipment/NoteSummaryCard";
import { RecipientSignForm } from "../components/signature/TypedSignature";

export default function MyEquipmentNotes() {
    const [items, setItems] = useState(null);
    const [signingId, setSigningId] = useState(null);

    const load = useCallback(async () => {
        try {
            const { data } = await api.get("/equipment/my-notes");
            setItems(data.items || []);
        } catch {
            setItems([]);
            toast.error("Impossible de charger vos bons");
        }
    }, []);

    useEffect(() => { load(); }, [load]);

    const sign = async (id, payload) => {
        setSigningId(id);
        try {
            await api.post(`/equipment/my-notes/${id}/sign`, payload);
            toast.success("Bon signé · le PDF vous est envoyé par email");
            load();
        } catch (err) {
            toast.error(err.response?.data?.detail || "Signature impossible");
        } finally {
            setSigningId(null);
        }
    };

    const pending = (items || []).filter((n) => !n.recipient_signed_at);
    const done = (items || []).filter((n) => n.recipient_signed_at);

    return (
        <div className="p-6 max-w-3xl space-y-6" data-testid="my-equipment-notes-page">
            <h1 className="text-2xl font-black text-slate-900 inline-flex items-center gap-2">
                <ClipboardCheck className="w-6 h-6 text-orange-500" /> Mes bons de matériel
            </h1>
            {items === null && <p className="text-sm text-slate-400">Chargement…</p>}
            {items && items.length === 0 && (
                <p className="text-sm text-slate-500" data-testid="my-equipment-notes-empty">Aucun bon de remise à votre nom pour le moment.</p>
            )}
            {pending.map((n) => (
                <section key={n.id} className="card-soft p-6 space-y-5" data-testid={`my-note-pending-${n.id}`}>
                    <div className="text-xs font-black uppercase tracking-widest text-amber-600">À signer</div>
                    <NoteSummaryCard note={n} />
                    <RecipientSignForm
                        defaultName={n.subject_full_name}
                        submitting={signingId === n.id}
                        onSubmit={(payload) => sign(n.id, payload)}
                        testid={`my-note-sign-${n.id}`}
                    />
                </section>
            ))}
            {done.length > 0 && (
                <section className="space-y-2">
                    <h2 className="text-sm font-extrabold uppercase tracking-widest text-slate-400">Historique</h2>
                    {done.map((n) => (
                        <div key={n.id} className="card-soft px-4 py-3 flex items-center justify-between gap-3" data-testid={`my-note-done-${n.id}`}>
                            <div className="text-sm">
                                <CheckCircle2 className="inline w-4 h-4 text-emerald-500 mr-1" />
                                <strong>{n.number}</strong> · {n.items.length} article(s) · {Number(n.total_value_eur || 0).toFixed(2)} €
                            </div>
                            {n.status === "signed" && (
                                <button onClick={() => openAuthedPdf(`/equipment/my-notes/${n.id}/pdf`)}
                                    className="inline-flex items-center gap-1 text-xs font-bold text-shariti-orange"
                                    data-testid={`my-note-pdf-${n.id}`}>
                                    <FileDown className="w-4 h-4" /> PDF
                                </button>
                            )}
                        </div>
                    ))}
                </section>
            )}
        </div>
    );
}
